.av-notification .av-card {
  cursor: pointer;
  width: 280px;
  border: 0;
  .av-card-body {
    padding: 10px 30px 10px 15px;
  }
}

.av-notification:not(.av-notification-confirm) .av-card:hover {
  @include darken-on-hover;
  .av-notification-close {
    opacity: 1;
  }
}

h3 {
  margin: 8px 0 12px 0;
  font-size: 1.1em;
}

.av-notification-confirm {
  .av-card.av-card-floating,
  .av-card.av-card-open.av-card-focus {
    z-index: 100100;
  }

  &::before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    z-index: 0;
    background-color: transparent;
    bottom: 20px;
    right: 20px;
    box-shadow: var(--av-box-shadow-confirm);
  }
  .av-card {
    cursor: default;
  }
}

.av-notification-error .av-card {
  background-color: var(--av-color-danger);
  color: var(--av-color-danger-contrast);
}

.av-notification-success .av-card {
  background-color: var(--av-color-success);
  color: var(--av-color-success-contrast);
}

.av-notification-warning .av-card {
  background-color: var(--av-color-warning);
  color: var(--av-color-warning-contrast);
}

.av-notification-info .av-card {
  background-color: var(--av-card-background-color);
  color: var(--av-card-color);
}

.av-notification-info-backdrop-blur .av-card {
  background: var(--av-card-background-blur-color);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.av-notification-close {
  position: absolute;
  top: 4px;
  right: 4px;
  opacity: 0;
  transition: opacity 0.2s ease-out;
}

.av-confirm-footer {
  text-align: right;
  padding: 4px 12px 12px;

  av-button:first-child {
    margin-right: 10px;
  }
}

av-asset {
  width: 100%;
}

.av-direction {
  direction: var(--av-direction);
}
